// The launch threshold is 10. REACT_APP_REPORT_MIN_MATCHES lowers it for a
// local walkthrough, where no listing has 10 AI-ranked buyers yet - the API
// itself renders a report from a single match. Only a positive integer is
// honoured, so a typo falls back to 10 rather than unlocking at zero.
const MIN_MATCHES_DEFAULT = 10;
// Digits only: parseInt would read "1.5" as 1, quietly unlocking at a number
// nobody typed.
const rawMinMatches = String(
  process.env.REACT_APP_REPORT_MIN_MATCHES ?? ""
).trim();
export const REPORT_MIN_MATCHES = /^\d+$/.test(rawMinMatches)
  ? Number(rawMinMatches) || MIN_MATCHES_DEFAULT
  : MIN_MATCHES_DEFAULT;

// Kill switch: the Buyer Match Report is merged but not launched. While this is
// false every surface falls back to its pre-launch "coming soon" state.
// REACT_APP_REPORT_ENABLED=true opts one build in (local review, demo PDFs);
// anything else - including the variable being absent - keeps it off.
const REPORT_ENABLED = process.env.REACT_APP_REPORT_ENABLED === "true";

export const isReportEnabled = () => REPORT_ENABLED;

export const meetsMatchThreshold = (matchCount) => {
  const n = Number(matchCount);
  return Number.isFinite(n) && n >= REPORT_MIN_MATCHES;
};

export const isReportUnlocked = (matchCount) =>
  REPORT_ENABLED && meetsMatchThreshold(matchCount);

export const matchesUntilUnlock = (matchCount) => {
  const n = Number(matchCount);
  const safe = Number.isFinite(n) ? n : 0;
  return Math.max(REPORT_MIN_MATCHES - safe, 0);
};

// The three states every report-gated surface renders, collapsed into one
// place so they can't drift: "coming-soon" (kill switch off - the report
// isn't launched, regardless of match count), "locked" (launched, but this
// property hasn't cleared REPORT_MIN_MATCHES yet), "unlocked" (launched and
// cleared). ActionDropdown/InventoryDetails already branched on
// isReportEnabled()/isReportUnlocked() to pick between these three - this
// names the result instead of leaving each caller to re-derive it.
export const reportCtaState = (matchCount) => {
  if (!isReportEnabled()) return "coming-soon";
  return meetsMatchThreshold(matchCount) ? "unlocked" : "locked";
};
